import { useEffect } from "react";
import { useSetRecoilState, useRecoilValue } from "recoil";
import { useLocation } from "react-router-dom";
import { promptOverridesState, currentAutomationState } from "../global-state";

const defaultPrompts = [
  {
    id: "automation-new",
    title: "Create and save a new automation, not to auto-start.",
    showOnLanding: true,
  },
];

// A hook to update the prompt overrides based on the current URL
export const usePromptOverridesUpdater = () => {
  const location = useLocation();
  const setPromptOverrides = useSetRecoilState(promptOverridesState);
  const currentAutomation = useRecoilValue(currentAutomationState);

  useEffect(() => {
    const { pathname } = location;

    if (
      pathname === "/automation/overview" &&
      (currentAutomation.automationId || currentAutomation.scriptId) &&
      currentAutomation.name
    ) {
      const prompts = [
        {
          id: "automation-new",
          title: "Create and save a new automation, not to auto-start.",
          showOnLanding: true,
        },
      ];

      // If we have a scriptId, we're viewing a draft
      if (currentAutomation.scriptId) {
        prompts.push({
          id: "automation-edit-draft",
          title: `Edit <automation scriptId="${currentAutomation.scriptId}">${currentAutomation.name}</automation> Create draft only, NOT auto save.`,
          showOnLanding: true,
        });
      } else if (currentAutomation.automationId) {
        // Regular automation (no draft)
        prompts.push({
          id: "automation-edit-draft",
          title: `Edit <entity type="basic.automation.Automation" typeName="Automation" name="${currentAutomation.name}" id="${currentAutomation.automationId}"></entity> Create draft only, NOT auto save.`,
          showOnLanding: true,
        });
      }
      setPromptOverrides(prompts);
    } else {
      // Otherwise, copy the default prompts
      setPromptOverrides([...defaultPrompts]);
    }
  }, [location, setPromptOverrides, currentAutomation]);
};

// A component to apply the updater hook.
// This should be placed high up in the component tree, inside RecoilRoot.
export const PromptUpdater = ({ children }) => {
  usePromptOverridesUpdater();
  return children;
};
